import React from 'react'
import LandingPage from './Pages/LandingPage'


function App() {
  return (
    <div className='bg-darkBlue h-screen w-screen overflow-x-hidden '>
      <LandingPage/>     
    </div>
  )
}

export default App

